module.exports = __webpack_public_path__ + "img/check-small.f0d1b553.svg";